import { useEffect } from 'react';
import { useSidebarCollapse } from 'context/SidebarCollapseContext';

/**
 * Collapse the left nav to its rail while this page is mounted, then restore
 * whatever the user had on the way out.
 *
 * The override is transient: it never writes the sidebar_collapsed preference,
 * so visiting Search does not change the nav on any other page. If the user
 * manually expands the nav while it is active, their choice wins for the rest
 * of the session (see SidebarCollapseContext).
 *
 * Pass `enabled: false` on mobile, where there is no rail to collapse to.
 */
export const useCollapseNavForPage = (enabled: boolean) => {
  const { requestPageCollapse, releasePageCollapse } = useSidebarCollapse();

  useEffect(() => {
    if (!enabled) return;
    requestPageCollapse();
    return releasePageCollapse;
  }, [enabled, requestPageCollapse, releasePageCollapse]);
};
